import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

function CardApresentacao() {
  return (
    <Card style={{ width: "80%", marginLeft: "10%", marginTop: "5%" }}>
      <Card.Img variant="top" src="https://i.imgur.com/suNBRq9.jpeg" />
      <Card.Body data-bs-theme="dark" className="transicao">
        <Card.Title>Um pouco sobre o RMV</Card.Title>
        <Card.Text>
          No momento faço minha segunda graduação em Engenharia de Computação
          pelo Instituto Infnet. Sou contador pelo IBMEC-RJ (sim, passei no
          exame do conselho) e, apesar de não ter exercido a profissão, ela me
          agregou muito na questão de visão de mundo. As Ciências Contábeis
          não são exatas, são sociais assim como economia e administração, coisa
          que vi bastante durante a graduação. Também fui monitor de Cálculo
          Diferencial e Integral 1 por quatro anos, sendo três na UFF e um no
          IBMEC. Gosto muito de jogos online, em particular MMOs, mas estou em
          abstinência, tentando aproveitar melhor o meu tempo, como construir/atualizar
          este site ou estudar assuntos diversos.
          <br /><br />
          Desperta a minha atenção atualmente (sujeito a alteração) o experimento com modelos de IA para automação e construção de coisas.
          Mas que coisas? Coisas que possam ser desenvolvidas por <a href="https://en.wikipedia.org/wiki/Knowledge_worker">Knowledge workers</a>, pelo menos enquanto a produção e manutenção 
          de robôs em massa ainda for restritiva por questões de custo e complexidade.<br />
          Sou um forte defensor da ideia de que, em 2026, o atual uso de IA ainda é a "ponta do iceberg" do que está por vir.
          Encaro a substituição do trabalho humano por IA como algo natural e inevitável, consequência da busca pelo lucro inerente ao
          capitalismo. Aos que pensam estarem imunes a isso, é uma questão de tempo até que a ferramenta evolua. E vai evoluir, 
          pois o investimento na tecnologia tem um potencial de retorno astronômico, dado que skills hoje altamente remuneradas
          por salário serão trivializadas por IA, ou que um só trabalhador faça o equivalente ao que múltiplos trabalhadores fazem hoje. 
          Seja qual for o caminho, isso leva a uma redução brutal de custos às empresas.
          <br />Note que esta avaliação de cenário é fortemente influenciada pela minha primeira graduação (Ciências Contábeis), e em menor grau 
          pela segunda que está em andamento (Engenharia de Computação).<br /><br />
          Acho que já escrevi muito. Não deixo o link do GitHub pois 99% do que
          está lá é privado, e mesmo assim está uma zona completa. Coloco todos os trabalhos da faculdade em um monorepo privado, seja para
          não passar vergonha publicamente, ou para que que outros não se "inspirem" no meu código, se é que você me entende.
        </Card.Text>
        <Button
          variant="info"
          onClick={() => alert("Olá Vitor. Em construção.")}
        >
          Não tem nada aqui
        </Button>
      </Card.Body>
    </Card>
  );
}

export default CardApresentacao;
